import { jsxs as r, jsx as e, Fragment as c } from "react/jsx-runtime";
import { Popover as s, PopoverButton as l, PopoverPanel as p } from "@headlessui/react";
import { AnimatePresence as d, motion as u } from "framer-motion";
import { SmallDoubleChevronLeft as h } from "../DateInput/Assets/SmallDoubleChevronLeft.js";
import { ToggleButton as x } from "../ToggleButton/index.js";
const w = ({
  options: t,
  value: a,
  onChange: o,
  size: i
}) => /* @__PURE__ */ r("div", { className: "jm-sticky jm-inset-y-0 jm-right-0 jm-z-[3] jm-flex jm-w-10 jm-cursor-pointer jm-items-center jm-justify-center jm-bg-inherit jm-px-1", children: [
  /* @__PURE__ */ e(s, { children: ({ open: j, close: n }) => /* @__PURE__ */ r(c, { children: [
    /* @__PURE__ */ e(
      l,
      {
        as: "div",
        className: "jm-custom-rotate-180 jm-flex jm-cursor-pointer jm-items-center jm-justify-center jm-rounded-md hover:jm-bg-jutro-new-warm-gray-100 active:jm-bg-jutro-new-warm-gray-200",
        children: /* @__PURE__ */ e(h, {})
      }
    ),
    /* @__PURE__ */ e(d, { children: j && /* @__PURE__ */ e(
      p,
      {
        static: !0,
        as: u.div,
        initial: { opacity: 0, scale: 0.95 },
        animate: { opacity: 1, scale: 1 },
        exit: { opacity: 0, scale: 0.95 },
        anchor: "bottom",
        className: `jm-z-[100] jm-flex jm-max-h-[800px] jm-flex-col jm-gap-2 jm-overflow-auto jm-rounded-lg jm-bg-white jm-p-2 jm-shadow-[0px_0px_26px_0px_#00000014] ${i === "condensed" ? "[--anchor-gap:13px]" : "[--anchor-gap:18px]"}`,
        children: t.map((m) => /* @__PURE__ */ e(
          x,
          {
            active: a.value === m.value,
            text: m.label,
            disabled: m.disabled,
            onClick: () => {
              o(m), n();
            }
          }
        ))
      }
    ) })
  ] }) }),
  /* @__PURE__ */ e("div", { className: "jm-absolute jm-inset-y-0 -jm-right-1 jm-z-[3] jm-w-1 jm-bg-inherit" })
] });
export {
  w as TabsPopoverMenu
};
//# sourceMappingURL=TabsPopoverMenu.js.map
